import { render, staticRenderFns } from "./CreateAttention.vue?vue&type=template&id=25888f0c&scoped=true"
import script from "./CreateAttention.vue?vue&type=script&lang=js"
export * from "./CreateAttention.vue?vue&type=script&lang=js"
import style0 from "./CreateAttention.vue?vue&type=style&index=0&id=25888f0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25888f0c",
  null
  
)

export default component.exports